import loader from './loader';
window.criteo_q = window.criteo_q || [];
var load = loader(function () {
  var d = document;
  var g = d.createElement('script');
  var s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.async = true;
  g.src = '//static.criteo.net/js/ld/ld.js';
  s.parentNode.insertBefore(g, s);
});
export default function () {
  var _window$criteo_q;

  load();
  return (_window$criteo_q = window.criteo_q).push.apply(_window$criteo_q, arguments);
}